export const CACHE_BLOCK_SIZE = 50;

export const serverSideColumnOptions = {
  filter: 'agTextColumnFilter',
};
